import React, {PureComponent} from "react";
import Api from "../utils/api_calls";
import Simplebar from "../libs/simplebar";
import LiveItem from "./live-search-result";
import "../../sass/components/_search-suggest.scss";

class SearchSuggest extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const that = this;
        setTimeout(function() {
            const scroller = document.getElementById("results-list-container");
            if (scroller)
                var simplebar = new Simplebar(scroller);
            if (simplebar)
                simplebar.getScrollElement().addEventListener("scroll", (e) => {
                    that.props.onScroll(e);
                });
        }, 100);
    }

    render() {
        const value = this.props.value || this.props.lastValue;
        const searchURL = TVSite.baseUrl + "search/?s=";
        const {loading, openResults, Results} = this.props;
        const noResults = !!(Results.length === 0 && openResults);
        return (
            <div className="search-suggest">

                <div id="search-suggest-content"
                     className={"search-suggest-content " + (openResults ? "" : "tvp-hide")}>
                    <div className="row">
                        <div className="results suggestions-line col-sm-12">
                            <div className="results-for">
                                results for <span>{value}</span>
                            </div>
                            <div id="results-list-container" className="results-list-container">
                                <ul id="results-list" className="results-list">
                                    {Results.map((result, index) => {
                                        return <li key={index}>
                                            <LiveItem identifier={index} video={result}/>
                                        </li>
                                    })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                {noResults &&
                <div className="search-suggest-content no-results">
                    <div className="no-results-text">{!loading ?
                        <span>NO RESULTS FOR {value}</span>
                        :
                        <span>SEARCHING FOR `{value}`</span>
                    }</div>
                </div>
                }
            </div>
        )
    }
}

export default SearchSuggest;

